<template>
  <div class="checkAccpet">
    <el-descriptions class="margin-top" size="medium" :column="1" border
                     :labelStyle="{'text-align': 'center','width':'20%','color':'#555'}">
      <el-descriptions-item label="现场照片">
        <!--        {{ formValidate.eventCheckImg }}-->
        <div style="display: flex;flex-direction: row;flex-wrap: wrap;align-content: flex-start;">
          <!--          <img v-for="(item,index) in formValidate.eventCheckImg" :src="item.url" :key="index" width="200" height="200"-->
          <!--               style="margin-right: 10px" @click="previewPic(item)"/>-->
          <el-image v-for="(item,index) in formValidate.eventCheckImg" :key="index"
                    style="width: 200px; height: 200px;margin-top: 10px;margin-right: 10px;"
                    :src="item"
                    :preview-src-list="formValidate.eventCheckImg">
          </el-image>
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="验收情况">
        {{ formValidate.eventCheck }}
      </el-descriptions-item>
    </el-descriptions>
    <!--    <div style="text-align: center">-->
    <!--      <Button type="primary" @click="handleSubmit('formValidate')">提交</Button>-->
    <!--    </div>-->

    <Modal
        v-model="showPic"
        title="预览"
        :footer-hide="true"
    >
      <img :src="selectPic.url" width="100%" height="100%"/>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "checkAccept",
  props: {
    eventInfo: {
      type: Object,
      default: () => {
      }
    },
    stepInfo: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showPic: false,
      selectPic: {},
      formValidate: {
        eventCheck: '',
        eventCheckImg: ''
      }
    }
  },
  mounted() {
    if (this.stepInfo !== '' && this.stepInfo !== null) {
      this.formatInfo()
    }
  },
  methods: {
    previewPic(item) {
      this.showPic = true
      this.selectPic = item
    },
    formatInfo() {
      console.log(this.stepInfo)
      let info = this.stepInfo.split(';')
      // console.log(info)
      info.forEach(item => {
        const obj = item.split('_')
        this.formValidate[obj[0]] = obj[1]
        if (obj[0] === 'eventCheckImg') {
          if (obj[1] === '[]') {
            this.formValidate.eventCheckImg = []
          } else {
            let str = ''
            for (let i = 1; i <= obj.length - 1; i++) {
              str = str + obj[i]
            }
            let list = JSON.parse(str)
            list = list.map(item => {
              return item.url
            })
            this.formValidate.eventCheckImg = list
          }
          // console.log(this.formValidate.eventCheckImg)
        }
      })
    },
    handleSubmit(name) {
      // this.$Message.success('Success!');
      let params = {
        currentLink: this.eventInfo.currentLink,
        indexCode: this.eventInfo.deptIndexCode,
        information: `eventCheck_${this.formValidate.eventCheck};eventCheckImg_${this.formValidate.eventCheckImg};`,
        messageId: this.eventInfo.id
      }
      // console.log(params)
      this.$http.post('/api/jumpNextLink', params).then(res => {
        console.log(res)
        this.$emit('refreshStep')
      })
    }
  }
}
</script>

<style scoped lang="less">
.checkAccpet {
  width: 60%;
  margin: 0 auto;
}
</style>
